import { render } from "./Admin_Pricings.vue?vue&type=template&id=7fbb644c"
import script from "./Admin_Pricings.vue?vue&type=script&lang=js"
export * from "./Admin_Pricings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__